export default `
    <span id="#=data.id#" class="#= data.classes || ""#"></span>
`;
